import React from 'react';

const TableHeader = () => (
  <div className="c-appointment-details-head">
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">No.</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="large-and-up-p--">
        <span className="c-appointment-details__heading">Service time</span>
      </span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">Client name</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">Service type</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">Barber name</span>
    </div>
    <div className="c-appointment-details-head__col">
      <span className="c-appointment-details__heading">Status</span>
    </div>
  </div>
);

export default TableHeader;
